export enum SidebarPlacementEnum {
    FIXED = 'fixed',
    OVERLAY = 'overlay',
}

export enum SidebarAlignmentEnum {
    LEFT = 'left',
    RIGHT = 'right',
}
